import { Link, useLocation } from 'react-router';
import { BOTTOM_BAR } from '../nav';
import { Icon } from './Icon';

function isActive(pathname: string, match: string[]): boolean {
  return match.some((m) =>
    m === '/' ? pathname === '/' : pathname === m || pathname.startsWith(`${m}/`),
  );
}

/** design/BottomBar.dc.html: Orçar · Fila · Pedidos · Estoque · Mais. */
export function BottomBar() {
  const { pathname } = useLocation();
  return (
    <nav className="bbar" aria-label="Navegação">
      {BOTTOM_BAR.map((item) => {
        const on = isActive(pathname, item.match);
        return (
          <Link
            key={item.to}
            to={item.to}
            className={on ? 'on' : ''}
            aria-current={on ? 'page' : undefined}
          >
            <Icon name={item.icon} size={24} />
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
